package one.healthium.profile.ui.update_initial_weight

import one.healthium.domain.user.UserModel

internal data class UpdateInitialWeightUiState(
    val loading: Boolean = false,
    val userModel: UserModel? = null,
    val isMetric: Boolean = true,
    val updatedWeight: Float? = null,
    val isTargetWeight: Boolean = false,
) {
    val hasInitialWeight = userModel != null
    val initialWeight = if (isTargetWeight) userModel?.profile?.targetWeight else userModel?.profile?.weight
    val weight = updatedWeight ?: initialWeight
}
